import * as React from 'react';
import { cn } from '@/lib/utils';

export interface SectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  /** Optional trailing control (e.g. a Button) aligned to the right. */
  action?: React.ReactNode;
}

/**
 * Consistent page/section heading: chunky clay heading + optional subtitle and
 * a right-aligned action. Replaces ad-hoc `<div><h1/><p/></div>` blocks.
 */
export function SectionHeader({
  title,
  description,
  action,
  className,
  ...props
}: SectionHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)} {...props}>
      <div className="min-w-0">
        <h1 className="font-heading text-2xl font-extrabold tracking-tight">{title}</h1>
        {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
